import { ChangeDetectionStrategy, Component, input } from '@angular/core';

/**
 * Single-family line-icon set (24x24, 1.75 stroke, round joins) so the whole
 * platform shares one hand instead of Material's default ligature icons.
 */
const PATHS: Record<string, string> = {
  pin: 'M12 21s-7-6.1-7-11.5A7 7 0 0 1 19 9.5C19 14.9 12 21 12 21Z M12 12.5a2.75 2.75 0 1 0 0-5.5 2.75 2.75 0 0 0 0 5.5Z',
  calendar: 'M4.5 6.75A1.75 1.75 0 0 1 6.25 5h11.5A1.75 1.75 0 0 1 19.5 6.75v11.5A1.75 1.75 0 0 1 17.75 20H6.25A1.75 1.75 0 0 1 4.5 18.25V6.75Z M4.5 10h15 M8 3v4 M16 3v4',
  users: 'M9 12.25a3.5 3.5 0 1 0 0-7 3.5 3.5 0 0 0 0 7Z M3.75 20c.6-3.2 2.9-5.25 5.25-5.25S13.65 16.8 14.25 20 M15.5 6.6a3 3 0 0 1 0 5.8 M17.5 14.4c2 .55 3.4 2.3 3.75 5.6',
  wallet: 'M3.5 7.75A1.75 1.75 0 0 1 5.25 6h12A1.75 1.75 0 0 1 19 7.75v9A1.75 1.75 0 0 1 17.25 18.5h-12A1.75 1.75 0 0 1 3.5 16.75v-9Z M15.5 12.25h2.5 M3.5 10h16',
  search: 'M11 18.5a7.5 7.5 0 1 0 0-15 7.5 7.5 0 0 0 0 15Z M16.4 16.4 21 21',
  star: 'M12 3.5 14.6 9l6 .9-4.3 4.2 1 6-5.3-2.8-5.3 2.8 1-6L3.4 9.9l6-.9L12 3.5Z',
  'arrow-right': 'M4 12h16 M14 6l6 6-6 6',
  'arrow-up-right': 'M6 18 18 6 M9 6h9v9',
  'chevron-right': 'm9 6 6 6-6 6',
  'chevron-left': 'm15 6-6 6 6 6',
  'chevron-down': 'm6 9 6 6 6-6',
  'heart-outline': 'M12 20.2s-7.8-4.6-9.4-9.6C1.6 6.9 4 4 7.3 4c2 0 3.5 1 4.7 2.6C13.2 5 14.7 4 16.7 4c3.3 0 5.7 2.9 4.7 6.6-1.6 5-9.4 9.6-9.4 9.6Z',
  heart: 'M12 20.2s-7.8-4.6-9.4-9.6C1.6 6.9 4 4 7.3 4c2 0 3.5 1 4.7 2.6C13.2 5 14.7 4 16.7 4c3.3 0 5.7 2.9 4.7 6.6-1.6 5-9.4 9.6-9.4 9.6Z',
  share: 'M17.5 8.25a2.75 2.75 0 1 0 0-5.5 2.75 2.75 0 0 0 0 5.5Z M6.5 14.75a2.75 2.75 0 1 0 0-5.5 2.75 2.75 0 0 0 0 5.5Z M17.5 21.25a2.75 2.75 0 1 0 0-5.5 2.75 2.75 0 0 0 0 5.5Z M8.9 13.2l6.2-3.9 M8.9 11.8l6.2 3.9',
  shield: 'M12 3 4.5 5.8v5.5c0 4.8 3.2 8.6 7.5 9.7 4.3-1.1 7.5-4.9 7.5-9.7V5.8L12 3Z M8.75 12l2.25 2.25L15.5 9.5',
  mail: 'M4 6.5A1.5 1.5 0 0 1 5.5 5h13A1.5 1.5 0 0 1 20 6.5v11A1.5 1.5 0 0 1 18.5 19h-13A1.5 1.5 0 0 1 4 17.5v-11Z M4.5 6.5l7.5 6.5 7.5-6.5',
  phone: 'M6.6 3.75h2.2l1.3 4.3-2 1.4a12.3 12.3 0 0 0 6.4 6.4l1.4-2 4.3 1.3v2.2c0 1-.85 1.8-1.85 1.7-7.4-.7-13.05-6.35-13.75-13.75-.1-1 .7-1.85 1.7-1.85Z',
  clock: 'M12 20.5a8.5 8.5 0 1 0 0-17 8.5 8.5 0 0 0 0 17Z M12 7.5V12l3 2',
  map: 'M9 4 4 6v14l5-2 6 2 5-2V4l-5 2-6-2Z M9 4v14 M15 6v14',
  check: 'm4.5 12.75 5 5 10-11',
  'zoom-in': 'M11 18.5a7.5 7.5 0 1 0 0-15 7.5 7.5 0 0 0 0 15Z M16.4 16.4 21 21 M11 8v6 M8 11h6',
  quote: 'M7.5 6.5c-2.5 1.5-4 3.9-4 6.7 0 2.4 1.6 4.3 3.8 4.3 2 0 3.4-1.5 3.4-3.4 0-1.8-1.2-3.1-2.9-3.3.3-1.5 1.3-2.8 2.7-3.6L7.5 6.5Zm9 0c-2.5 1.5-4 3.9-4 6.7 0 2.4 1.6 4.3 3.8 4.3 2 0 3.4-1.5 3.4-3.4 0-1.8-1.2-3.1-2.9-3.3.3-1.5 1.3-2.8 2.7-3.6L16.5 6.5Z',
  compass: 'M12 20.5a8.5 8.5 0 1 0 0-17 8.5 8.5 0 0 0 0 17Z M14.8 9.2 13 13l-3.8 1.8L11 11l3.8-1.8Z',
  badge: 'M12 2.5 14 5l3.3-.3.6 3.3 2.9 1.6-1.6 2.9.3 3.3-3.3.6-1.6 2.9-2.9-1.6-2.9 1.6-1.6-2.9-3.3-.6.3-3.3-1.6-2.9L5.7 8l.6-3.3L9.6 5 12 2.5Z M8.75 12l2.25 2.25L15.5 9.5',
  close: 'M6 6l12 12M18 6L6 18',
  menu: 'M4 7h16M4 12h16M4 17h16',
  play: 'M8 5.5v13l11-6.5-11-6.5Z',
  facebook: 'M14.5 8.5h2V5.2c-.35-.05-1.5-.2-2.85-.2-2.85 0-4.65 1.75-4.65 4.9v2.6H6v3.6h3v8.9h3.6v-8.9h3l.5-3.6h-3.5V10.2c0-1.05.3-1.7 1.9-1.7Z',
  instagram: 'M7 4h10a3 3 0 0 1 3 3v10a3 3 0 0 1-3 3H7a3 3 0 0 1-3-3V7a3 3 0 0 1 3-3Z M12 15.2a3.2 3.2 0 1 0 0-6.4 3.2 3.2 0 0 0 0 6.4Z M16.3 7.7h.01',
  send: 'M21 3 3 10.5l7 2.5 2.5 7L21 3Z M10 13l4.5-4.5',
  globe: 'M12 20.5a8.5 8.5 0 1 0 0-17 8.5 8.5 0 0 0 0 17Z M3.7 9h16.6 M3.7 15h16.6 M12 3.5c2.2 2.3 3.4 5.2 3.4 8.5s-1.2 6.2-3.4 8.5c-2.2-2.3-3.4-5.2-3.4-8.5S9.8 5.8 12 3.5Z',
  leaf: 'M5 19c8.5 0 14-5.5 14-14 0 0-9-1-13 3S5 19 5 19Z M5 19c0-4 1.5-7.5 5-10',
  gem: 'M4 9l3.5-5h9L20 9l-8 11L4 9Z M4 9h16 M9.5 4l1 5-2.5 0 M14.5 4l-1 5 2.5 0',
  train: 'M6 3.5h12a1.5 1.5 0 0 1 1.5 1.5v9a3.5 3.5 0 0 1-3.5 3.5H8A3.5 3.5 0 0 1 4.5 14V5A1.5 1.5 0 0 1 6 3.5Z M4.5 10h15 M8 20.5 6 22.5 M16 20.5l2 2 M8.5 14.5h.01 M15.5 14.5h.01',
  mountain: 'M3 19h18 M4.5 19 10 8l3 4.5 2-2.5L19.5 19',
  waves: 'M3 8c1.8-1.5 3.6-1.5 5.4 0s3.6 1.5 5.4 0 3.6-1.5 5.4 0 M3 14c1.8-1.5 3.6-1.5 5.4 0s3.6 1.5 5.4 0 3.6-1.5 5.4 0 M3 20c1.8-1.5 3.6-1.5 5.4 0s3.6 1.5 5.4 0 3.6-1.5 5.4 0',
  temple: 'M12 2.5 15 6H9l3-3.5Z M6.5 6h11v2h-11z M7 9h10v9.5H7z M4 18.5h16v2H4z M10 12h4v6.5h-4z',
  route: 'M5 19c3 0 3-5 6-5s3 5 6 5 M5 8.5a2 2 0 1 0 0-4 2 2 0 0 0 0 4Z M19 8.5a2 2 0 1 0 0-4 2 2 0 0 0 0 4Z M5 19a2 2 0 1 0 0-4 2 2 0 0 0 0 4Z M19 19a2 2 0 1 0 0-4 2 2 0 0 0 0 4Z',
  filter: 'M4 6h16 M7 12h10 M10 18h4',
  moon: 'M20 14.5A8.5 8.5 0 1 1 9.5 4a6.5 6.5 0 0 0 10.5 10.5Z',
  camera: 'M4 8.5A1.5 1.5 0 0 1 5.5 7h1.9l1-1.6c.27-.44.75-.9 1.6-.9h4c.85 0 1.33.46 1.6.9l1 1.6h1.9A1.5 1.5 0 0 1 20 8.5v9A1.5 1.5 0 0 1 18.5 19h-13A1.5 1.5 0 0 1 4 17.5v-9Z M12 16.2a3.5 3.5 0 1 0 0-7 3.5 3.5 0 0 0 0 7Z',
  wind: 'M3 8h11.5a2.25 2.25 0 1 0-2.25-2.25 M3 12.5h15.5a2.5 2.5 0 1 1-2.5 2.5 M3 17h9.5a2 2 0 1 1-2 2',
  flame: 'M12 3c2.6 3.3 5 6.3 5 9.7a5 5 0 0 1-10 0C7 9.3 9.4 6.3 12 3Z M12 11.2c1 1.1 1.5 1.9 1.5 2.8a1.5 1.5 0 0 1-3 0c0-.9.5-1.7 1.5-2.8Z',
  droplet: 'M12 3.2c3.1 4 6 7.6 6 11.3a6 6 0 0 1-12 0c0-3.7 2.9-7.3 6-11.3Z',
};

@Component({
  selector: 'app-icon',
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: `
    <svg
      [attr.viewBox]="'0 0 24 24'"
      [attr.width]="size()"
      [attr.height]="size()"
      fill="none"
      stroke="currentColor"
      [attr.stroke-width]="strokeWidth()"
      stroke-linecap="round"
      stroke-linejoin="round"
      aria-hidden="true"
      focusable="false"
    >
      <path [attr.d]="path()" />
    </svg>
  `,
  styles: [
    `
      :host {
        display: inline-flex;
        line-height: 0;
      }
    `,
  ],
})
export class Icon {
  name = input.required<string>();
  size = input<number>(20);
  strokeWidth = input<number>(1.75);

  path() {
    return PATHS[this.name()] ?? PATHS['pin'];
  }
}
